import checkEnvironment from '../checkEnvironment';

const getAssetTypeApiUrl = () => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/endpoints/assettypes`;
};

export default getAssetTypeApiUrl;
